<!--
Author: TangChen
Date: 2018-12-26
Desc: 定投基金详情，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-plan-detail bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">
                    我的资产
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <el-table :data="fundInfo" style="width: 100%" :show-header="false">
            <el-table-column label="基金信息">
                <template slot-scope="scope">
                    <el-row class="fund-list">
                        <el-col :span="24" class="fund-tit">
                            <el-col :span="18" class="fund-info">
                                <span style="cursor: pointer;" @click="gotoDetail(scope.row)">
                                    <span v-html="getFundName(scope.row)" />
                                    <i class="risk" :class="$util.riskCla(scope.row.risklevel)">{{ $cache.getDict('110143',scope.row.risklevel)+'风险' }}</i>
                                </span>
                            </el-col>
                            <el-col :span="6" class="plan-fund-btn">
                                <el-button
                                    v-if="cancelflag"
                                    type="yellow"
                                    size="mini"
                                    v-on:click.prevent="btnAction('cl')"
                                >
                                    <i class="plan-icon change" />撤单
                                </el-button>
                                <el-button
                                    v-if="scope.row.statusText.indexOf('c')>-1"
                                    type="yellow"
                                    size="mini"
                                    v-on:click.prevent="btnAction('c')"
                                >
                                    <i class="plan-icon change" />修改
                                </el-button>
                                <el-button
                                    v-if="scope.row.statusText.indexOf('s')>-1"
                                    type="red"
                                    size="mini"
                                    v-on:click.prevent="btnAction('s')"
                                >
                                    <i class="plan-icon start" />恢复
                                </el-button>
                                <el-button
                                    v-if="scope.row.statusText.indexOf('p')>-1"
                                    type="red"
                                    size="mini"
                                    v-on:click.prevent="btnAction('p')"
                                >
                                    <i class="plan-icon pause" />暂停
                                </el-button>
                                <el-button
                                    v-if="scope.row.statusText.indexOf('e')>-1"
                                    type="blue"
                                    size="mini"
                                    v-on:click.prevent="btnAction('e')"
                                >
                                    <i class="plan-icon end" />终止
                                </el-button>
                                <el-tooltip
                                    v-else
                                    class="item"
                                    effect="info"
                                    :content="'定投状态为' + $cache.getDict('110008', scope.row.status) + ',不允许操作'"
                                    placement="left"
                                >
                                    <el-button type="lock" size="mini">
                                        <i class="plan-icon end" />终止
                                    </el-button>
                                </el-tooltip>
                            </el-col>
                        </el-col>
                        <el-col :span="24">
                            <p>定投计划名称：<span>{{ scope.row.planname }}</span></p>
                            <p v-if="scope.row.planflag==='2'||scope.row.planflag==='6'">
                                定投计划说明：<span>{{ scope.row.specification }}</span>
                            </p>
                        </el-col>
                        <el-col :span="3" class="align-c">
                            <span>{{ $cache.getDict('110008', scope.row.status) }}</span>
                            <p>定投状态</p>
                        </el-col>
                        <el-col :span="4" class="align-c">
                            <span>{{ $util.fmtDate(scope.row.firstinvestdate) }}</span>
                            <p>首次扣款日期</p>
                        </el-col>
                        <el-col :span="3" class="align-c">
                            <span>{{ scope.row.periodremark }}</span>
                            <p>扣款周期</p>
                        </el-col>
                        <el-col :span="4" class="align-c">
                            <span>{{ scope.row.firstinvestamount }}</span>
                            <p>每期定投金额(元)</p>
                        </el-col>
                        <el-col :span="4" class="align-c">
                            <span>{{ (scope.row.planpaytype==='1'?'银行卡':'现金宝')+(scope.row.planflag==='2'||scope.row.planflag==='6'?'(智慧定投)':'') }}</span>
                            <p>定投策略</p>
                        </el-col>
                        <el-col :span="6" class="align-c">
                            <div class="bank-img-sel list-bank">
                                <span class="k-text-flow">{{ $cache.getDict('110080',scope.row.channelid)+'[尾号'+scope.row.bankcard.substr(-4,4)+']' }}</span>
                                <i class="paycenter">{{ $cache.getDict('110079',scope.row.paycenterid) }}</i>
                            </div>
                            <p>银行卡</p>
                        </el-col>
                    </el-row>
                </template>
            </el-table-column>
        </el-table>
        <msg-dialog v-if="dialog" :dialog="dialog" :private-info="wisdomInfo" v-on:event-fn="btnDialog" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import msgDialog from "@/components/misc/msgDialog";
import format from "date-fns/format";
export default {
    name: "PlanDetail",
    components: {
        msgDialog
    },
    mixins: [mixin],
    data () {
        return {
            fund: {},
            fundInfo: [],
            wisdomInfo: {},
            dialog: false,
            cancelflag: false,
            cancelOrderId:""
        };
    },
    created () {
        // 获取基金信息
        const _x = JSON.parse(sessionStorage.getItem(this.$route.name));
        const _y = _x.risklevel.split(",").sort();
        _x.risklevel = _y[_y.length - 1];
        this.getFundInfo(_x);
        this.qryOrderCancel();
    },
    methods: {
        qryOrderCancel(){
            let url = "trade/order/cancel";
            const param = {
                begindate: this.$util.getBeginDate(format(new Date(), "YYYYMMDD"), 1, true),
                enddate: format(new Date(), "YYYYMMDD"),
                sourceflag: "1",
                keyword: "",
                businesscode: "59",//定投
                pagecount: "",
                pageoffset: 0,
                cancelflag: true,
            };
            this.$util.request(url, param).then(res => {
                if (res.data) {
                    if (res.data.length > 0) {
                        let _this = this;
                        res.data.forEach(item => {
                            if(item.fundcode === _this.fund.fundcode && item.protocolno === _this.fund.planno){
                                _this.cancelflag = true;
                                _this.cancelOrderId = item.appsheetserialno;
                            }
                        })
                    }
                }
            });
        },
        gotoDetail(val){
            this.$util.toCompPage("/fund",{secondtype: val.fundcode,etfflag: val.etfflag});
        },
        // 获取基金可用操作
        getNewFund () {
            const acctStatus = this.$cache.getUser().status;
            const status = this.fund.status;
            const planStyle = this.fund.planflag;
            let btnArr = "";
            // 组合定投
            if (planStyle === "a" || planStyle === "b") {
                if (status === "N") {
                    btnArr = "e";
                } else if (status === "P") {
                    if (acctStatus === "7") {
                        btnArr = "e";
                    } else {
                        btnArr = "s,e";
                    }
                }
            } else { // 普通定投
                if (status === "N") {
                    if (acctStatus === "7") {
                        btnArr = "p,e";
                    } else {
                        btnArr = "c,p,e";
                    }
                } else if (status === "P") {
                    if (acctStatus === "7") {
                        btnArr = "e";
                    } else {
                        btnArr = "c,s,e";
                    }
                }
            }
            this.fund.statusText = btnArr;
            this.$set(this.fundInfo, 0, this.fund);
        },
        // 按钮响应处理
        btnAction (cate) {
            if (cate === "s" || cate === "c") {
                this.fund.proto = "plan";
                this.$util.fundRiskCheck(this, this.fund, res => {
                    if (res) {
                        let _url = "";
                        let _way = "";
                        if (cate === "s") {
                            _url = "generalrecovery";
                            _way = "G2";
                        } else if (cate === "c") {
                            _url = "generalchange";
                            _way = "61";
                        }
                        const _x = Object.assign({}, res, { way: _way });
                        sessionStorage.setItem(_url, JSON.stringify(_x));
                        this.$router.push({ name: _url, query: { fundcode: _x.fundcode } });
                    }
                });
                return;
            }
            let _x = {method: "PUT"};
            if (cate === "p") {
                _x.cateText = "暂停";
                _x.url = "trade/plan/pause";
                _x.way = "G1";
            } else if (cate === "e") {
                _x.cateText = "终止";
                _x.url = "trade/plan/recovery";
                _x.way = "60";
            }else if(cate === "cl"){
                _x.cateText = "撤销";
                _x.url = "trade/cancel";
                _x.method = "POST";
            }
            _x.cate = cate;

            _x.msg = "您确定执行" + this.fund.fundname + "(" + (this.fund.fundcode === "515981" ? "515980" : this.fund.fundcode) + ")基金" + _x.cateText + "定投协议操作？";
            _x.tit = _x.cateText + "定投协议提示";
            _x.tit = _x.cateText + "定投协议提示";
            _x.btn1 = "确认" + _x.cateText;
            _x.btn2 = "取消";
            this.wisdomInfo = _x;
            this.dialog = true;
        },
        // 获取基金名称显示
        getFundName (val) {
            let _k = "";
            let _m = ",";
            if (val.fundcode.indexOf(",") === -1) {
                return _k + val.fundname + "(" + (val.fundcode === "515981" ? "515980" : val.fundcode) + ")";
            }
            const _x = val.fundcode.split(",");
            const _y = val.fundname.split(",");
            let _z = "";
            // 定转显示
            for (let i in _x) {
                _z += _k + _y[i] + "(" + _x[i] + ")" + _m;
            }
            return _z.substr(0, _z.length - 1);
        },
        // 按钮弹窗提示信息
        btnDialog (val) {
            const _this = this;
            if (val) {
                let _x = {
                    planno: this.fund.planno,
                    tradepwd: val.tpasswd
                };
                let _url = "trade/plan/" + (_this.fund.planpaytype === "1" ? "normal" : "xjb") + "/pause";
                if (val.cate === "e") {
                    _url = "trade/plan/" + (_this.fund.planpaytype === "1" ? "normal" : "xjb") + "/end";
                }
                if(val.cate === "cl"){
                    _x = {
                        orderid: this.cancelOrderId,
                        tradepwd: val.tpasswd || ""
                    }
                    _url = val.url;
                }
                // 组合定投终止
                if (this.fund.planflag === "a" || this.fund.planflag === "b") {
                    _url = "trade/plan/combine";
                    _x.saveplanflag = this.fund.planflag;
                    _x.mainplanno = this.fund.mainplanno;
                }
                this.$util.request(_url, _x, val.method).then(res => {
                    if(val.cate === "cl"){
                        this.$router.push({ name: "myplan"});
                    }
                    if (res.data) {
                        _this.getFundInfo(_this.fund);
                    }
                });
            } else {
                this.dialog = false;
            }
        },
        // 获取定投协议信息
        getFundInfo (data) {
            let _this = this;
            let url = "trade/plan/normal";
            if (data.planpaytype === "2") {
                url = "trade/plan/xjb";
            }
            let _x = { planno: data.planno };
            if (data.planflag === "a" || data.planflag === "b") {
                _x = { planno: "", mainplanno: data.mainplanno };
            }
            this.$util.request(url, _x).then(res => {
                if (res.data) {
                    if(res.data[0].comrate === "0.0000" || res.data[0].mainplanno.trim() === ""){
                        res.data[0].comrate = "";
                    }
                    if (data.planflag === "a" || data.planflag === "b") {
                        _this.fund = Object.assign({}, data, { planname: res.data[0].planname, status: res.data[0].status });
                    } else {
                        _this.fund = Object.assign({}, data, res.data[0]);
                    }
                    _this.getNewFund();
                }
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-plan-detail {
    .el-table--fit {
        margin-bottom: 10px;
        &:before {
            display: none;
        }
    }
    .el-table td {
        border: none;
    }
    .el-table .cell {
        padding: 0px 20px;
    }
    .fund-list {
        .plan-fund-btn {
            text-align: right;
            .el-button--mini {
                padding: 5px 15px;
            }
            .plan-icon {
                display: inline-block;
                width: 21px;
                height: 23px;
                margin: 0 5px 0 0;
                border: none;
                padding: 0;
                border-radius: 0;
                background: url($icon) no-repeat;
                &.change {
                    background-position: -319px -2px;
                }
                &.start {
                    background-position: -372px -94px;
                }
                &.pause {
                    background-position: -341px -2px;
                }
                &.end {
                    background-position: -365px -2px;
                }
            }
        }
    }
}
</style>
